<template>
    <div class="vue-insta-slider">
        <hooper ref="instaSlider" :settings="hooperSettings">
            <slot></slot>
        </hooper>

        <ef2-slider-navigation
            @slider-next="handleSliderNext"
            @slider-previous="handleSliderPrevious"
        ></ef2-slider-navigation>
    </div>
</template>

<script>
export default {
    name: "InstaSlider",

    data() {
        return {
            hooperSettings: {
                wheelControl: false,
                infiniteScroll: false,
                mouseDrag: false,
                //itemsToSlide: 1,
                breakpoints: {
                    1920: {
                        itemsToShow: 6.5
                    },
                    1200: {
                        itemsToShow: 5.5
                    },
                    768: {
                        itemsToShow: 3.25,
                    },
                    0: {
                        itemsToShow: 1.75,
                    }
                }
            },
        }
    },

    methods: {
        handleSliderNext() {
            this.$refs.instaSlider.slideNext();
            window.blazy();
        },

        handleSliderPrevious() {
            this.$refs.instaSlider.slidePrev();
            window.blazy();
        }
    }
}
</script>